module.exports = __webpack_public_path__ + "static/media/ss-tic-tac-toe.fe74b443.gif";